(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selectors = [
    'main .shopify-section h2:not(.card__heading)',
    'main .aw-grid > li',
    'main .product-grid > .grid__item',
    'main .multicolumn-list > li',
    'main .aw-compare > *',
    'main .rich-text__blocks > *',
    'main .newsletter__wrapper > *',
    'main .collapsible-content__grid > *',
    'main .aw-trust__item'
  ];

  let observer;

  const reveal = (element) => {
    element.classList.add('is-aw-visible');
    observer?.unobserve(element);
  };

  const prepare = (root = document) => {
    const elements = [...root.querySelectorAll(selectors.join(','))];

    elements.forEach((element) => {
      if (element.dataset.awReveal || element.classList.contains('scroll-trigger')) return;

      element.dataset.awReveal = 'true';
      element.classList.add('aw-reveal');

      if (element.matches('.aw-grid > li, .product-grid > .grid__item, .multicolumn-list > li')) {
        element.classList.add('aw-reveal--scale');
      }

      const group = element.parentElement;
      const siblings = group ? [...group.children].filter((item) => item.matches?.('[data-aw-reveal]')) : [];
      const index = Math.max(0, siblings.indexOf(element));
      element.style.setProperty('--aw-reveal-delay', `${Math.min(index * 70, 280)}ms`);

      if (reduceMotion.matches || !observer) reveal(element);
      else observer.observe(element);
    });
  };

  const init = () => {
    if (!reduceMotion.matches && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }

    prepare();

    document.addEventListener('shopify:section:load', () => prepare(document));
    document.addEventListener('shopify:section:reorder', () => prepare(document));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
